import { render, staticRenderFns } from "./bussetting.vue?vue&type=template&id=80a58d72&"
import script from "./bussetting.vue?vue&type=script&lang=js&"
export * from "./bussetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports